import { cn } from '@avanta/shared/utils/cn';
import { sanitizeMessageHtml } from '@avanta/shared/utils/text';

export const RichMessageText = ({ html }: { html: string }): React.ReactElement => (
  <span
    className={cn(
      '[&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5',
      '[&_li]:my-0.5',
      '[&_strong]:font-semibold [&_b]:font-semibold',
      '[&_em]:italic [&_i]:italic',
      '[&_s]:line-through',
      '[&_u]:underline',
      '[&_mark]:bg-yellow-200 [&_mark]:rounded-sm [&_mark]:px-0.5',
      '[&_a]:underline [&_a]:text-teal-700',
      '[&_code]:bg-gray-100 [&_code]:rounded [&_code]:px-1 [&_code]:text-sm [&_code]:font-mono',
      '[&_p]:mb-1 last:[&_p]:mb-0'
    )}
    dangerouslySetInnerHTML={{ __html: sanitizeMessageHtml(html) }}
  />
);
